<template>

  <div>
    <div class="btn-group">
      <div class="btn btn-dark">
        #{{ selected.length }}
      </div>

      <JobMassiveActionMove
        v-if="jobActions" />

      <button
        v-if="jobActions"
        type="button"
        class="btn btn-secondary"
        @click="action='email'"
        v-tooltip="$t('Send email')">
        <i class="fas fa-envelope" />
      </button>

      <button
        v-if="jobActions"
        type="button"
        class="btn btn-secondary"
        @click="action='share'"
        v-tooltip="$t('Share')">
        <i class="fas fa-share" />
        </button>

      <JobMassiveActionDisqualify
        v-if="jobActions"
        @disqualifyNotification="action='email'" />

      <div class="btn-group">
        <button
          class="btn btn-secondary dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          {{ $t('More') }}
        </button>
        <div class="dropdown-menu">
          <JobMassiveActionRequalify
            v-if="jobActions"/>
          <JobMassiveActionRenew
            v-if="jobActions" />
          <button
            v-if="jobActions"
            type="button"
            class="dropdown-item"
            @click="action='event'">
            <i class="far fa-calendar-alt" /> {{ $t('Schedule') }}
            </button>
          <button
            v-if="jobActions"
            type="button"
            class="dropdown-item"
            @click="action='questionnaire'">
            <i class="fas fa-clipboard" /> {{ $t('Request questionnaire') }}
            </button>
          <button
            v-if="jobActions"
            type="button"
            class="dropdown-item"
            @click="action='intervideo'">
            <i class="fas fa-video" /> {{ $t('Request video interview') }}
            </button>
          <button
            type="button"
            class="dropdown-item"
            @click="action='assign'">
            <i class="fas fa-sign-in-alt" /> {{ $t('Assign to job') }}
            </button>
          <JobMassiveActionDelete />
          <JobMassiveActionConsentRequest
            v-if="gdprEnable" />
          <JobMassiveActionDiversityRequest
            v-if="diversityEnable" />
        </div>
      </div>
    </div>

    <JobMassiveActionEmail
      v-if="action === 'email'"
      @close="action=null" />

    <JobMassiveActionEvent
      v-if="action === 'event'"
      @close="action=null" />

    <JobMassiveActionShare
      v-if="action === 'share'"
      @close="action=null" />

    <JobMassiveActionIntervideo
      v-if="action === 'intervideo'"
      @close="action=null" />

    <JobMassiveActionIntervoice
      v-if="action === 'intervoice'"
      @close="action=null" />

    <JobMassiveActionQuestionnaire
      v-if="action === 'questionnaire'"
      @close="action=null" />

    <JobMassiveActionAssign
      v-if="action === 'assign'"
      @close="action=null" />
  </div>

</template>

<script>
import JobMassiveActionMove from './JobMassiveActionMove'
import JobMassiveActionDisqualify from './JobMassiveActionDisqualify'
import JobMassiveActionRequalify from './JobMassiveActionRequalify'
import JobMassiveActionShare from './JobMassiveActionShare'
import JobMassiveActionEmail from './JobMassiveActionEmail'
import JobMassiveActionEvent from './JobMassiveActionEvent'
import JobMassiveActionIntervideo from './JobMassiveActionIntervideo'
import JobMassiveActionIntervoice from './JobMassiveActionIntervoice.vue'
import JobMassiveActionQuestionnaire from './JobMassiveActionQuestionnaire'
import JobMassiveActionAssign from './JobMassiveActionAssign'
import JobMassiveActionRenew from './JobMassiveActionRenew'

import JobMassiveActionDelete from './JobMassiveActionDelete'
import JobMassiveActionConsentRequest from './JobMassiveActionConsentRequest'
import JobMassiveActionDiversityRequest from './JobMassiveActionDiversityRequest'

export default {
  name: 'JobMassiveAction',
  components: {
    JobMassiveActionMove,
    JobMassiveActionDisqualify,
    JobMassiveActionRequalify,
    JobMassiveActionShare,
    JobMassiveActionEmail,
    JobMassiveActionEvent,
    JobMassiveActionIntervideo,
    JobMassiveActionIntervoice,
    JobMassiveActionQuestionnaire,
    JobMassiveActionAssign,
    JobMassiveActionRenew,
    JobMassiveActionDelete,
    JobMassiveActionConsentRequest,
    JobMassiveActionDiversityRequest
  },
  props: {
    jobActions: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      action: null
    }
  },
  computed: {
    gdprEnable () {
      const account = this.$store.getters.getAccount
      return account.settings.gdpr
    },
    diversityEnable () {
      const account = this.$store.getters.getAccount
      return account.settings.diversity
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveAction.vue